import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

export default async function getBookingSources() {
    try {
        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/booking-sources/`,
            {
                withCredentials: true,
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get booking sources: ${axiosError.message}`,
            axiosError,
        )

        throw new Error(axiosError.message)
    }
}
